/* Season 9 offer: the client side of snippets/pr-offer.liquid. Self contained on purpose: the
   theme carries a PageSpeed packer (snippets/scripts.liquid) that kills inline scripts on Linux
   browsers until the first mouse move, so nothing here depends on an inline script having run.
   1. Location: set <html data-pr-ship / data-pr-customs> from the store region, then confirm the
      shopper's country with Shopify's own lookup once per session. Until confirmed nothing
      promises free shipping.
   2. Money, one currency per sentence: shoppers whose currency is not pinned in the settings get
      every GBP anchor converted with Shopify.currency.rate (the rate the checkout converts the
      discount minimum with), rounded UP to a clean number for thresholds and DOWN for reward
      values, printed in the shop's own money format. The bar then compares the bag against the
      very figure it prints, so it never promises a rung the checkout does not grant.
   3. Free gift: at tier 3 add the gift to the bag and take it out again if Shopify does not make
      it free (no automatic discount yet), so a gift is never charged.
   4. Customs: the cart field posts its value as a cart attribute so it lands on the order. */
;(function () {
  if (window.__prOffer) return; window.__prOffer = true;
  var cfg;
  try { cfg = JSON.parse(document.getElementById('pr-offer-config').getAttribute('content')); } catch (e) { return; }
  if (!cfg || !cfg.enabled) return;
  window.PROffer = cfg;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var H = document.documentElement;

  /* 1. location ------------------------------------------------------------------------- */
  function decide(det) {
    /* "*" covers every destination (the store's profile has a catch-all International zone with a
       free rate above the threshold); otherwise the shopper's country must be on the list, and the
       location lookup must agree before anything promises free shipping. */
    var all = cfg.ship.indexOf('*') > -1;
    var ok = all || cfg.ship.indexOf(cfg.country) > -1;
    if (det) { ok = ok && (all || cfg.ship.indexOf(det) > -1); }
    else if (cfg.strict) { ok = false; }
    /* zones whose free rate starts ABOVE the tier are never promised it, however the list above is
       set. Measured 2026-09-30: an Australian bag still pays 4.75 at 160 and only goes free at 165,
       while the rung says 155. */
    var no = cfg.shipNo || [];
    if (no.indexOf(cfg.country) > -1 || (det && no.indexOf(det) > -1)) { ok = false; }
    var cc = '';
    if (cfg.customs[cfg.country]) { cc = cfg.country; }
    else if (det && cfg.customs[det]) { cc = det; }
    H.setAttribute('data-pr-ship', ok ? 'yes' : 'no');
    H.setAttribute('data-pr-customs', cc);
    cfg.detected = det || null;
  }
  function lookup() {
    var cached = null;
    try { var s = sessionStorage.getItem('pr_geo'); if (s) cached = JSON.parse(s); } catch (e) {}
    if (cached) { decide(cached.c); return; }
    decide(null);
    fetch(ROOT + 'browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        c = c ? String(c).toUpperCase() : null;
        try { sessionStorage.setItem('pr_geo', JSON.stringify({ c: c, t: Date.now() })); } catch (e) {}
        decide(c);
      })
      .catch(function () { /* the safe default stands */ });
  }

  /* 2. money ---------------------------------------------------------------------------- */
  function rate() { var sc = (window.Shopify && Shopify.currency) || {}; return parseFloat(sc.rate) || 1; }
  function iso() { var sc = (window.Shopify && Shopify.currency) || {}; return sc.active || 'GBP'; }
  /* a clean step for the currency: 1 for strong ones, 10 or 100 for weak ones (CZK, JPY, ...) */
  function step() { var r = rate(); return r >= 100 ? 100 : (r >= 10 ? 10 : 1); }
  function convert(gbpCents, dir) {
    var units = gbpCents / 100 * rate(), st = step();
    var clean = dir === 'down' ? Math.floor(units / st) * st : Math.ceil(units / st) * st;
    return Math.round(clean * 100);
  }
  function fmt(cents) {
    var t = window.theme || {};
    var out = '';
    if (t.Shopify && t.Shopify.formatMoney && t.money_format) out = t.Shopify.formatMoney(cents, t.money_format);
    else { try { out = new Intl.NumberFormat(undefined, { style: 'currency', currency: iso() }).format(cents / 100); } catch (e) { out = (cents / 100).toFixed(2) + ' ' + iso(); } }
    /* no trailing zeros, the same way the server prints them */
    return out.replace(/([.,])00(?=\D*$)/, '');
  }
  function pct(into, span) { if (span <= 0) return 0; var p = into * 100 / span; return p > 100 ? 100 : (p < 0 ? 0 : p); }

  function applyMoney(el) {
    if (el.__prFx) return; el.__prFx = true;
    var b = parseInt(el.getAttribute('data-gbp'), 10) || 0;
    if (!b) return;
    var c = convert(b, el.getAttribute('data-round'));
    el.setAttribute('data-cents', c);
    el.textContent = fmt(c);
  }

  function applyLadder(el) {
    if (el.__prFx) return; el.__prFx = true;
    var cur = parseInt(el.getAttribute('data-current'), 10) || 0;
    var listed = el.getAttribute('data-listed') === '1';
    var tiers = el.querySelectorAll('.rewards__tier');
    var prev = 0, nextAmt = 0, nextLabel = '';
    for (var i = 0; i < tiers.length; i++) {
      var gbp = parseInt(tiers[i].getAttribute('data-gbp'), 10) || 0;
      /* listed currency: the threshold is final on the server, so use the figure the rung was
         printed with. Converting it again here could disagree with what is on screen. */
      var min = listed ? (parseInt(tiers[i].getAttribute('data-min'), 10) || 0) : (gbp ? convert(gbp, 'up') : 0);
      if (!min) return;                                       /* nothing to measure against */
      tiers[i].setAttribute('data-min', min);
      /* each rung has its OWN base: a reward never counts toward its own threshold, so the tier 3
         rung is measured on the bag with a charged bandana taken back out of it (Liquid writes
         data-spend; stripSync keeps it fresh between page loads) */
      var sp = tiers[i].getAttribute('data-spend');
      var tcur = sp === null || sp === '' ? cur : (parseInt(sp, 10) || 0);
      var fill = tiers[i].querySelector('.rewards__seg-fill');
      if (fill) fill.style.width = (tcur > prev ? pct(tcur - prev, min - prev) : 0) + '%';
      var done = tcur >= min;
      tiers[i].classList.toggle('is-done', done);
      if (!done && !nextLabel) { nextAmt = min - tcur; nextLabel = (tiers[i].querySelector('.rewards__label') || {}).innerHTML || ''; }
      prev = min;
    }
    /* the gift candidates in the upsell row hide once the last rung is reached: at tier 3 the
       bandana / hat is the reward, not a £35 add-on (CSS in snippets/pr-offer-head.liquid) */
    if (tiers.length) { var lw = el.closest('[data-pr-ladder-wrap]'); if (lw) lw.setAttribute('data-pr-last-done', nextLabel ? '0' : '1'); }
    var msg = el.querySelector('.rewards__msg');
    if (!msg) return;
    if (nextLabel) {
      msg.innerHTML = (el.getAttribute('data-copy-next') || '[amount] more unlocks [reward]')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace('[amount]', '<strong class="pr-amt">' + fmt(nextAmt) + '</strong>')
        .replace('[reward]', '<strong>' + nextLabel + '</strong>');
      el.classList.remove('rewards--complete');
    } else {
      msg.textContent = el.getAttribute('data-copy-done') || 'Every reward unlocked';
      el.classList.add('rewards--complete');
    }
  }

  /* The free gift row: which rung the bag has earned. Liquid settles it when the shopper's
     currency is pinned in the settings; when it is not, the thresholds travelled as GBP anchors
     and the decision is made here off the same convert() every other figure uses, so the row can
     never offer a gift the checkout would charge for. Tier 3 wins outright: Shopify runs ONE
     automatic Buy X Get Y per order, so past 250 the hat or bandana replaces the gift card. */
  function applyClaim(el) {
    if (el.getAttribute('data-listed') === '1') return;
    var s1 = parseInt(el.getAttribute('data-s1'), 10) || 0;
    var s3 = parseInt(el.getAttribute('data-s3'), 10) || 0;
    var g1 = parseInt(el.getAttribute('data-t1-gbp'), 10) || 0;
    var g3 = parseInt(el.getAttribute('data-t3-gbp'), 10) || 0;
    var c1 = g1 ? convert(g1, 'up') : 0;
    var c3 = g3 ? convert(g3, 'up') : 0;
    el.setAttribute('data-show', c3 && s3 >= c3 ? '3' : (c1 && s1 >= c1 ? '1' : ''));
  }

  function scan(root) {
    var r = root || document;
    var cl = r.querySelectorAll('[data-pr-claim]');
    for (var q = 0; q < cl.length; q++) applyClaim(cl[q]);
    var m = r.querySelectorAll('[data-pr-fx="0"] .pr-money');
    for (var i = 0; i < m.length; i++) applyMoney(m[i]);
    var l = r.querySelectorAll('[data-pr-ladder][data-listed="0"]');
    for (var j = 0; j < l.length; j++) applyLadder(l[j]);
    var w = r.querySelectorAll('[data-pr-fx="0"]:not(.is-ready)');
    for (var k = 0; k < w.length; k++) w[k].classList.add('is-ready');
    var c = r.querySelectorAll('[data-pr-customs-input]');
    for (var n = 0; n < c.length; n++) bindCustoms(c[n]);
    if (r.querySelector && (r.querySelector('.cqa') || r.querySelector('[data-pr-ladder]'))) flagsSoon();
    /* mirror "last rung reached" (server side when the currency is listed, applyLadder otherwise)
       onto <html> so the drawer's add-on row can drop the gift candidates */
    var lw = document.querySelector('.cart-drawer [data-pr-ladder-wrap], [data-pr-ladder-wrap]');
    if (lw && lw.hasAttribute('data-pr-last-done')) document.documentElement.setAttribute('data-pr-tier-last', lw.getAttribute('data-pr-last-done'));
  }

  /* 3. free gift ------------------------------------------------------------------------ */
  var giftBusy = false;
  /* The nth rung's threshold in cart cents. Same source as the ladder a shopper can see, so the
     auto-add can never fire at a number the page is not showing. */
  function tierCents(idx) {
    var wrap = document.querySelector('[data-pr-ladder-wrap]');
    if (!wrap) return 0;
    var tiers = wrap.querySelectorAll('[data-pr-ladder] .rewards__tier');
    var el = idx < 0 ? tiers[tiers.length + idx] : tiers[idx];
    if (!el) return 0;
    if (wrap.getAttribute('data-pr-fx') === '0') return convert(parseInt(el.getAttribute('data-gbp'), 10) || 0, 'up');
    return parseInt(el.getAttribute('data-min'), 10) || 0;
  }
  function tier1Cents() { return tierCents(0); }

  function tier3Cents() {
    var wrap = document.querySelector('[data-pr-ladder-wrap]');
    if (!wrap) return 0;
    var last = null, tiers = wrap.querySelectorAll('[data-pr-ladder] .rewards__tier');
    for (var i = 0; i < tiers.length; i++) last = tiers[i];
    if (!last) return 0;
    if (wrap.getAttribute('data-pr-fx') === '0') return convert(parseInt(last.getAttribute('data-gbp'), 10) || 0, 'up');
    return parseInt(last.getAttribute('data-min'), 10) || 0;
  }
  function cartJson(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function announce() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  }
  /* Both gifts are one size, so the bag fills them in rather than asking (David, 2026-09-30).
     WHICH one is the whole problem. Shopify runs ONE automatic Buy X Get Y per order, so the
     rungs do not stack: past tier 3 the hat or bandana REPLACES the 10 gift card, and a bag
     holding both gets CHARGED for the card. Proven on a real cart 2026-09-30: 295 of pants plus a
     bandana plus a gift card gave the bandana at 0 and still took 10 for the card.

     So exactly one gift is ever in the bag: tier 3's when tier 3 is reached, tier 1's when only
     tier 1 is, neither below that. Crossing 250 swaps the card out before the hat goes in. And
     every add is checked afterwards: if Shopify charged for it, it comes straight back out and
     the auto-add stops for the session rather than quietly billing someone for a free gift. */
  /* Off since 2026-10-01: the gifts are EG Auto Add's job (David: "remove the pr studio add to
     cart gifts, its bad, i will do it via the eg add to cart app"). The theme must not add, swap
     or remove a gift line any more, or it will fight EG over the bag. Kept as a no-op so nothing
     that calls it breaks. */
  function giftCheck() {}

  /* 4. customs field -------------------------------------------------------------------- */
  function bindCustoms(input) {
    if (input.__prBound) return; input.__prBound = true;
    var t;
    function save() {
      var key = input.getAttribute('data-pr-customs-key');
      if (!key) return;
      var attrs = {}; attrs[key] = input.value.trim();
      cartJson(ROOT + 'cart/update.js', { attributes: attrs }).then(function () {
        input.classList.toggle('is-saved', input.value.trim().length > 0);
      }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(save, 500); });
    input.addEventListener('change', function () { clearTimeout(t); save(); });
    input.addEventListener('blur', function () { clearTimeout(t); save(); });
  }

  /* 4b. Taiwan: required before checkout --------------------------------------------------
     David, 2026-10-14: Taiwan orders must carry the name in Chinese characters and the national ID
     or ARC number. Checkout cannot take extra fields on this plan, so the bag is the gate: while
     <html data-pr-customs="TW">, every checkout link or button waits for both fields, saves them as
     cart attributes, then goes on to checkout. Express buttons are hidden in CSS for Taiwan.
     ID formats accepted: national ID A123456789, the 2021 resident number A800000014, the old ARC
     AB12345678 (one letter, then a letter or digit, then eight digits). */
  var TW_HAN = /[㐀-䶿一-鿿豈-﫿]/g;
  var TW_NAME = /^[㐀-䶿一-鿿豈-﫿·‧・\s]+$/;
  var TW_ID = /^[A-Z][A-Z0-9][0-9]{8}$/;
  function twBox() {
    var boxes = document.querySelectorAll('[data-pr-tw]');
    for (var i = 0; i < boxes.length; i++) if (boxes[i].offsetParent !== null) return boxes[i];
    return boxes[0] || null;
  }
  function twCheck(box) {
    var name = box.querySelector('[data-pr-tw-field="name"]');
    var id = box.querySelector('[data-pr-tw-field="id"]');
    var err = box.querySelector('[data-pr-tw-error]');
    if (!name || !id) return { ok: true };
    id.value = id.value.toUpperCase().replace(/[\s-]+/g, '');
    var nv = name.value.trim();
    var nameOk = TW_NAME.test(nv) && (nv.match(TW_HAN) || []).length >= 2;
    var idOk = TW_ID.test(id.value);
    name.classList.toggle('is-invalid', !nameOk);
    id.classList.toggle('is-invalid', !idOk);
    var msg = [];
    if (!nameOk) msg.push('Add your full name in Chinese characters.');
    if (!idOk) msg.push('Add your Taiwan ID (1 letter and 9 digits) or ARC number.');
    if (err) { err.textContent = msg.join(' '); err.hidden = !msg.length; }
    return { ok: nameOk && idOk, name: name, id: id, first: !nameOk ? name : id };
  }
  function twGate(e, trigger) {
    if (H.getAttribute('data-pr-customs') !== 'TW') return;
    var box = twBox();
    if (!box) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var r = twCheck(box);
    if (!r.ok) {
      try { r.first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {}
      r.first.focus();
      return;
    }
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    var attrs = {};
    attrs['Taiwan: Chinese name'] = r.name.value.trim();
    attrs['Taiwan: ID number'] = r.id.value;
    var go = function () { window.location.href = ROOT + 'checkout'; };
    cartJson(ROOT + 'cart/update.js', { attributes: attrs }).then(go, go);
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"], .secure-checkout, button[name="checkout"], input[name="checkout"]') : null;
    if (t) twGate(e, t);
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.getAttribute('name') === 'checkout') twGate(e, s);
  }, true);
  document.addEventListener('input', function (e) {
    var f = e.target;
    if (f && f.hasAttribute && f.hasAttribute('data-pr-tw-field') && f.classList.contains('is-invalid')) {
      var box = f.closest('[data-pr-tw]'); if (box) twCheck(box);
    }
  });

  /* 4. the top band ------------------------------------------------------------------------ */
  /* The band carries the clock on its own until the bag has something in it, and only then the
     ladder (David, 2026-09-26: a ladder over an empty bag is a price list, not progress). The bag
     changes without a page load, so the band is re-read from /cart.js on every cart change and
     the rungs are recomputed from the real subtotal. It measures items_subtotal_price, the same
     base the server and the checkout's discount minimum use. */
  /* A REWARD NEVER COUNTS TOWARD ITS OWN RUNG. Shopify's Buy X Get Y takes its "buy" amount from
     the lines other than the one it gives away, so 249 of clothes plus a 35 bandana is a 284 bag
     that wins nothing (real cart, 2026-09-30). Each gift rung measures the subtotal LESS whatever
     is still being charged for that rung's own gift products; a gift that is actually free is
     already a 0 line and drops out by itself. Mirrors snippets/pr-offer.liquid. */
  function bases(cart) {
    var g1 = cfg.gift && cfg.gift.t1 || [], g3 = cfg.gift && cfg.gift.t3 || [];
    var all = cart.items_subtotal_price, h1 = 0, h3 = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var h = String(cart.items[i].handle || '').toLowerCase();
      if (g1.indexOf(h) > -1) h1 += cart.items[i].final_line_price;
      if (g3.indexOf(h) > -1) h3 += cart.items[i].final_line_price;
    }
    return { all: all, t1: all - h1, t3: all - h3 };
  }

  function stripSync(cart) {
    var strip = document.querySelector('[data-pr-strip]');
    if (!strip) return;
    var has = !!(cart && cart.item_count > 0);
    /* no clock on this theme and nothing in the bag means the band would be empty, so it states
       the offer instead. Keep both classes in step or emptying the bag leaves a blank strip. */
    var hasClock = !!strip.querySelector('.pr-strip__cd');
    if (has) strip.classList.add('pr-strip--bag'); else strip.classList.remove('pr-strip--bag');
    if (!has && !hasClock) strip.classList.add('pr-strip--bare');
    else strip.classList.remove('pr-strip--bare');
    if (!has) return;
    var base = bases(cart);
    var bars = strip.querySelectorAll('[data-pr-ladder]');
    for (var i = 0; i < bars.length; i++) {
      bars[i].setAttribute('data-current', base.all);
      var rungs = bars[i].querySelectorAll('.rewards__tier');
      /* rungs are drawn in amount order, so the first is tier 1 and the last is tier 3; the
         shipping rung in between is charged on the whole bag */
      for (var j = 0; j < rungs.length; j++) {
        rungs[j].setAttribute('data-spend', j === 0 ? base.t1 : (j === rungs.length - 1 ? base.t3 : base.all));
      }
      bars[i].__prFx = false;                                 /* recompute, do not skip */
      applyLadder(bars[i]);
    }
  }
  /* Any ladder in a [data-pr-live] box (the product page's rewards card) follows the bag the way
     the strip does: same per-rung bases, so a reward never counts toward its own rung. */
  function liveSync(cart) {
    var boxes = document.querySelectorAll('[data-pr-live]');
    if (!boxes.length || !cart) return;
    var base = bases(cart);
    for (var b = 0; b < boxes.length; b++) {
      var bars = boxes[b].querySelectorAll('[data-pr-ladder]');
      for (var i = 0; i < bars.length; i++) {
        bars[i].setAttribute('data-current', base.all);
        var rungs = bars[i].querySelectorAll('.rewards__tier');
        for (var j = 0; j < rungs.length; j++) {
          rungs[j].setAttribute('data-spend', j === 0 ? base.t1 : (j === rungs.length - 1 ? base.t3 : base.all));
        }
        bars[i].__prFx = false;
        applyLadder(bars[i]);
      }
    }
  }
  /* 5. the add-on that closes the gap ---------------------------------------------------- */
  /* David 2026-10-01, the Park Friends rule: if adding THIS add-on reaches the next unreached
     rung, say so on its card. The next rung is the first .rewards__tier without is-done in the
     drawer's own ladder; its data-spend is that rung's base (a reward never counts toward its own
     rung, so a gift product is never said to unlock the gift rung), data-price is the candidate's
     price in the same currency. Nothing is promised for rungs that are already done or further
     away than the next one. */
  function upsellFlags() {
    var ladder = document.querySelector('.cart-drawer [data-pr-ladder]');
    var cards = document.querySelectorAll('.cart-drawer .cqa');
    if (!cards.length) return;
    var rungs = ladder ? ladder.querySelectorAll('.rewards__tier') : [];
    var next = null, nextIdx = -1;
    for (var i = 0; i < rungs.length; i++) { if (!rungs[i].classList.contains('is-done')) { next = rungs[i]; nextIdx = i; break; } }
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c], flag = card.querySelector('[data-cqa-flag]');
      var on = false, text = '';
      if (next) {
        var price = parseInt(card.getAttribute('data-price'), 10) || 0;
        var base = parseInt(next.getAttribute('data-spend'), 10) || 0;
        var min = tierCents(nextIdx === rungs.length - 1 ? -1 : nextIdx) || (parseInt(next.getAttribute('data-min'), 10) || 0);
        var isGift = card.getAttribute('data-pr-gift') === '1';
        var giftRung = nextIdx === rungs.length - 1;   /* the last rung is the free gift */
        if (price > 0 && min > 0 && !(isGift && giftRung) && base < min && base + price >= min) {
          on = true;
          var label = next.querySelector('.rewards__label');
          text = 'Add to unlock ' + (label ? label.textContent.trim().toLowerCase() : 'the next reward');
        }
      }
      card.classList.toggle('cqa--unlocks', on);
      if (flag) { flag.textContent = text; flag.hidden = !on; }
    }
  }
  /* one pass per burst: the drawer re-render and every app that touches the page used to queue a
     flags pass each (2026-10-01 tap profile: 400 ms of querySelector per cart change at 4x CPU) */
  var flagsT = 0;
  function flagsSoon() { if (flagsT) return; flagsT = setTimeout(function () { flagsT = 0; upsellFlags(); }, 120); }
  function stripRefresh() {
    if (!document.querySelector('[data-pr-strip]') && !document.querySelector('[data-pr-live]')) return;
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { stripSync(c); liveSync(c); upsellFlags(); }).catch(function () {});
  }

  /* wiring --------------------------------------------------------------------------------- */
  function boot() {
    lookup();
    scan();
    document.addEventListener('theme:cartchanged', function () { setTimeout(stripRefresh, 250); });
    /* Re-scan only what arrived, once per burst. The old observer ran a whole document scan (seven
       querySelectorAll calls) for EVERY mutation batch with an added node: the drawer re-render,
       each pixel iframe, each widget, our own ladder message. Measured 2026-10-01 at 4x CPU: 1.4 s
       of main thread per quantity tap. Now an added element is only kept when it, or something
       inside it, is one of ours, and the kept roots are scanned together on the next tick. */
    try {
      var SEL = '[data-pr-claim],[data-pr-fx="0"],.pr-money,[data-pr-ladder],[data-pr-customs-input],.cqa';
      var pend = [], pendT = 0;
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var a = muts[i].addedNodes;
          for (var k = 0; k < a.length; k++) {
            var n = a[k];
            if (n.nodeType !== 1 || !n.isConnected) continue;
            if (n.matches(SEL)) pend.push(n.parentNode || n);
            else if (n.querySelector(SEL)) pend.push(n);
          }
        }
        if (!pend.length || pendT) return;
        pendT = setTimeout(function () {
          pendT = 0; var roots = pend; pend = [];
          for (var i = 0; i < roots.length; i++) { if (roots[i].isConnected) scan(roots[i]); }
        }, 0);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
